import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {POLL_QUESTION, POLL_QUESTION_WEB, POLL_WEB} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";
import {pollFilterMixin} from "../FilterMixin";

export default {
    mixins: [DatatableHelperMixin,pollFilterMixin],
    data() {
        return {
            options: {
                name: this.$t('pollQuestions.title'),
                url: POLL_QUESTION,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('pollQuestions.question_text'),
                        type: 'text',
                        key: 'question_text',
                        isVisible: true,
                    },
                    {
                        title: this.$t('pollQuestions.question_type'),
                        type: 'text',
                        key: 'question_type',
                        isVisible: true,
                    },
                    {
                        title: this.$t('poll'),
                        type: 'custom-html',
                        key: 'poll',
                        isVisible: true,
                        modifier: (value) => {
                            return value ? value.title : 'Not Available';
                        }
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('yes'),
                        type: 'custom-html',
                        key: 'yes_answer',
                        isVisible: this.$isAdmin(),
                        modifier: (value) => {
                            return value ? value : 0;
                        }
                    },
                    {
                        title: this.$t('no'),
                        type: 'custom-html',
                        key: 'no_answer',
                        isVisible: this.$isAdmin(),
                        modifier: (value) => {
                            return value ? value : 0;
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('poll'),
                        type: "multi-select-filter",
                        key: "polls",
                        option: [],
                        listValueField: 'title',
                        permission: !!this.$can('view_polls')
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        name: 'view_details',
                        url: POLL_QUESTION_WEB,
                    },
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-poll-question-modal',
                        modalId: 'poll-question-modal',
                        url: POLL_QUESTION,
                        name: 'edit',
                        modifier: row => this.$can('update_poll_question')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'poll-question-modal',
                        url: POLL_QUESTION,
                        name: 'delete',
                        modifier: row => this.$can('delete_poll_question')
                    },
                ],
            }
        }
    }
}
